module.exports = __webpack_public_path__ + "fonts/Inter-700-vietnamese68.9df1755.woff2";